import React from 'react';
import PropTypes from 'prop-types';
import { iconBranching } from 'utils/svgConstants';

const MinimizedField = ({ branchIds, title }) => (
  <div className="minimized-field text-secondary position-relative d-flex justify-content-between">
    <div className="bg-light d-inline position-relative pr-2">
      {title}
    </div>
    <div className="bg-light pl-2 d-flex">
      <svg className="" xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 512 512">
        <g transform="rotate(270, 256, 256)">
          <path d={iconBranching} />
        </g>
      </svg>
      <div className="pl-2">
        {branchIds.join(', ')}
      </div>
    </div>
  </div>
);

MinimizedField.propTypes = {
  title: PropTypes.string.isRequired,
  branchIds: PropTypes.array.isRequired,
};
export default MinimizedField;
